"use client";

import React from "react";

const Loader = () => {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-red-100 via-white to-red-50 flex flex-col items-center justify-center z-[9999]">
      <div className="flex flex-col items-center gap-4">
        <img 
          src="/logo.png" 
          alt="T.H Academy" 
          className="w-28 h-28 animate-pulse"
        />
        <div className="loader-spinner"></div>

        <p className="text-gray-700 font-medium text-lg">
          جاري التحميل...
        </p>
      </div>

      <style>{`
        .loader-spinner {
          width: 40px;
          height: 40px;
          border: 4px solid #ddd;
          border-top-color: #ff3e3e;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Loader;
